module.exports = __webpack_public_path__ + "static/media/jardinModif3.4137482c.jpg";